import { ProductAdditives } from '../../../../services/exports/Constants';

export default {
  title: 'Zusatzstoffe',
  options: {
    [ProductAdditives.AcesulfamK]: 'Acesulfam K',
    [ProductAdditives.AceSucralose]: 'Ace-Sucralose',
    [ProductAdditives.Aesculin]: 'AESCULIN',
    [ProductAdditives.Agar]: 'Agar',
    [ProductAdditives.Anthocyanin]: 'Anthocyanin',
    [ProductAdditives.Antioxidant]: 'Antioxidationsmittel',
    [ProductAdditives.AntioxidantAscorbicAcid]: 'Antioxidationsmittel: Ascorbinsäure',
    [ProductAdditives.AntioxidantTocopherols]: 'Antioxidationsmittel: Tocopherole',
    [ProductAdditives.Flavor]: 'Aroma',
    [ProductAdditives.Flavors]: 'Aromen',
    [ProductAdditives.AscorbicAcid]: 'Ascorbinsäure',
    [ProductAdditives.Aspartame]: 'Aspartam',
    [ProductAdditives.OysterSauce]: 'Austernsauce',
    [ProductAdditives.BakingAid]: 'Backmittel',
    [ProductAdditives.BakingPowder]: 'Backpulver',
    [ProductAdditives.BalsamicVinegar]: 'Balsamico',
    [ProductAdditives.BalsamicCream]: 'Balsamico Crema',
    [ProductAdditives.BasilPesto]: 'Basilikum-Pesto',
    [ProductAdditives.BenzoicAcid]: 'Benzoesäure',
    [ProductAdditives.BetaCarotene]: 'Beta-Carotin',
    [ProductAdditives.Betain]: 'Betain',
    [ProductAdditives.BeetrootRed]: 'Betanin',
    [ProductAdditives.Beeswax]: 'Bienenwachs',
    [ProductAdditives.Bitters]: 'Bitterstoffe',
    [ProductAdditives.BlueCuracao]: 'Blue Curacao',
    [ProductAdditives.BlueCuracaoSyrup]: 'Blue Curacao Sirup',
    [ProductAdditives.BrandyVinegar]: 'Branntweinessig',
    [ProductAdditives.Broth]: 'Brühe',
    [ProductAdditives.Caffeine]: 'Caffein',
    [ProductAdditives.Calcium]: 'Calcium',
    [ProductAdditives.Caramel]: 'Karamell',
    [ProductAdditives.CaramelColor]: 'Karamellfarbe / Caramel Color',
    [ProductAdditives.CaramelE150d]: 'Karamell E150d',
    [ProductAdditives.Carotene]: 'Carotin',
    [ProductAdditives.CayennePepper]: 'Cayennepfeffer',
    [ProductAdditives.Chili]: 'Chili',
    [ProductAdditives.ChiliDressing]: 'Chili-Dressing',
    [ProductAdditives.ChiliMayonnaise]: 'Chili-Mayonnaise',
    [ProductAdditives.ChiliOil]: 'Chilli-Öl',
    [ProductAdditives.Quinine]: 'Chinin',
    [ProductAdditives.Chlorophyll]: 'Chlorophyll',
    [ProductAdditives.CitricAcid]: 'Citronensäure',
    [ProductAdditives.CitrusAcid]: 'Citrussäure',
    [ProductAdditives.CarbonDioxide]: 'CO2',
    [ProductAdditives.CocktailSauce]: 'Cocktailsoße',
    [ProductAdditives.Curry]: 'Curry',
    [ProductAdditives.CurryPaste]: 'Currypaste',
    [ProductAdditives.CurryPowder]: 'Curry-Pulver',
    [ProductAdditives.CurryCreamSauce]: 'Curry-Sahnesauce',
    [ProductAdditives.Fragrance]: 'Duftstoffe',
  },
};
